import React from "react";
import { useContext } from "react";
import { AppContext } from "../context";

const Search = () => {
  const { query, setQuery } = useContext(AppContext);
  return (
    <section className="search-section">
      <h1>Search your Favourite Movie</h1>
      <form action="#" onSubmit={(e) => e.preventDefault}>
        <input
          type="text"
          placeholder="Search here.."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
      </form>
    </section>
  );
};

export default Search;
